import React from 'react'
import { BackHandler, Platform } from 'react-native'

import { useFocusEffect, useNavigation } from '@react-navigation/native'
import {
  useAddCustomerNextState,
  useAddCustomerNextStateWeb,
} from '@zet/customer/src/api/hooks'
import useAddCustomerStore from '@zet/customer/src/store/addCustomer'
import { useExperiments } from '@zet/experiments'
import { isApp } from '@zet/utils'

const AddCustomerBackHandlerHOC = ({
  children,
  isDemoSale = false,
}: {
  children: React.ReactNode
  isDemoSale?: boolean
}) => {
  const { data } = useExperiments()
  const { goBack } = useNavigation()
  const { mutate } = useAddCustomerNextState()
  const { customerId } = useAddCustomerStore((store) => store)
  const { mutate: mutateWithExperiment } = useAddCustomerNextStateWeb()

  //! Back handler for add customer flow
  useFocusEffect(
    React.useCallback(() => {
      const onBackPress = () => {
        if (data?.UI_isAddCustomerNewFlow && isApp) {
          mutate({
            customerId: customerId,
            screenName: 'BACK',
            isDemoSale: isDemoSale,
          })
        } else if (data?.UI_isAddCustomerNewFlow && Platform.OS === 'web') {
          mutateWithExperiment({ customerId: customerId, screenName: 'BACK' })
        } else {
          goBack()
        }
        return true
      }

      const subscription = BackHandler.addEventListener(
        'hardwareBackPress',
        onBackPress,
      )

      return () => subscription.remove()
    }, [customerId, data?.UI_isAddCustomerNewFlow, goBack, mutate]),
  )

  return <>{children}</>
}

export default AddCustomerBackHandlerHOC
